import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    app: {
      companies: [],
      analysts: [],
    },
    test: {
      analyst: '',
      instrument: '',
      message: '',
    },
  },
  mutations: {
    setTest(state, payload) {
      state.test.analyst = payload.analyst;
      state.test.instrument = payload.instrument;
      state.test.message = payload.message;
    },
    setCompanies(state, payload) {
      state.app.companies = payload;
    },
    setAnalysts(state, payload) {
      state.app.analysts = payload;
    },
  },
  actions: {
    async fetchTestData(context) {
      const response1 = await axios.get(`${context.getters.VUE_APP_APING_URL}/insights/analysts/analyst/?analyst_id=564`);
      const data1 = await response1.data;
      const response2 = await axios.get(`${context.getters.VUE_APP_APING_URL}/quotes/v4/instruments/search/?query=aapl&domain=fool.com`);
      const data2 = await response2.data;
      const response3 = await axios.post(`${context.getters.VUE_APP_APING_URL}/insights/common/slack/`, {
        message: Math.round(Math.random() * 1000000000),
        person: 'iq@fool.com',
      });
      const data3 = await response3.data;
      context.commit('setTest', {
        analyst: data1.name,
        instrument: data2.SearchResults[0].Name,
        message: data3.inputs.message,
      });
      return [data1, data2, data3];
    },
    async fetchCompanies({ commit, getters }) {
      const { data } = await axios.get(`${getters.VUE_APP_APING_URL}/insights/companies/`);
      commit('setCompanies', data);
    },
    async fetchAnalysts({ commit, getters, state }) {
      const { data } = await axios.get(`${getters.VUE_APP_APING_URL}/insights/analysts/`);
      commit('setAnalysts', data);
    },
  },
  getters: {
    VUE_APP_TOKEN: state => window.env.VUE_APP_TOKEN,
    VUE_APP_APING_URL: state => window.env.APING_URL,
    companiesAutocompleteData: state => state.app.companies.map(company => `${company.symbols} ${company.name} #${company.id}`),
    analystsAutocompleteData: state => state.app.analysts.filter(analyst => analyst.active && !analyst.is_tester).map(analyst => ({
      key: `${analyst.name} #${analyst.id}`,
      val: analyst.avatar,
    })),
  },
  modules: {},
  strict: window.env.ENVIRONMENT === 'development',
});
